import { HelmetDexteel } from "@dexteel/mesf-core";
import { MillSetupSheetManager } from "./components/MillSetupSheetManager";

export const MillSetupSheetPage = () => {
	return (
		<>
			<HelmetDexteel title="Mill Setup Sheet" />
			<MillSetupSheetManager />
		</>
	);
};
